import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnumType } from 'src/app/core/enumerations/enum-type';
import { EnumMaster } from 'src/app/core/interfaces/enum-master';
import { environment } from 'src/environments/environment';
import { EndPoints } from 'src/app/shared/EndPoints';
import { HttpService } from 'src/app/core/services/http/http.service';
import { isNullOrUndefined } from 'util';

import { Constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class EnumService {

  private CPortalBaseUrl: string;
  stateList: any = [];
  raceList: any = [];
  ethnicityList: any = [];

  constructor(private httpService: HttpService,
              private localStorageService: LocalStorageService) {
    this.CPortalBaseUrl = environment.customerPortalServiceUrl;
  }

  public getOrderEnumMasterFilterByType(type: string): Observable<EnumMaster[]> {
    return this.httpService
      .Get(this.CPortalBaseUrl + EndPoints.GET_ORDER_ENUM + type);
  }

  public getRaceAndEthnicity(type: string) {
    return this.httpService
      .AsyncGet(this.CPortalBaseUrl + EndPoints.GET_ORDER_ENUM + type);
  }

  public getOrderEnumMasterFilterByTypeAndSubType(type: string, subType: string): Observable<EnumMaster[]> {
    return this.httpService
      .Get(this.CPortalBaseUrl + EndPoints.GET_ORDER_ENUM + type + '/' + subType);
  }

  public getUserEnumMasterFilterByType(type: string): Observable<EnumMaster[]> {
    return this.httpService
      .Get(this.CPortalBaseUrl + EndPoints.GET_USER_ENUM + type);
  }

  public getUserEnumMasterFilterByTypeAndSubType(type: string, subType: string): Observable<EnumMaster[]> {
    return this.httpService
      .Get(this.CPortalBaseUrl + EndPoints.GET_USER_ENUM + type + '/' + subType);
  }

  public getTestEnumMasterFilterByType(type: string): any {
    return this.httpService
      .Get(this.CPortalBaseUrl + EndPoints.GET_TEST_ENUM + type);
  }

  public getTestEnumMasterFilterByTypeAndSubType(type: string, subType: string): Observable<EnumMaster[]> {
    return this.httpService
      .Get(this.CPortalBaseUrl + EndPoints.GET_TEST_ENUM + type + '/' + subType);
  }

  public getEventEnumMasterFilterByType(type: string): any {
    return this.httpService
      .Get(this.CPortalBaseUrl + EndPoints.GET_EVENT_ENUM + type);
  }

  public getStateList() {
    return this.httpService.AsyncGet(this.CPortalBaseUrl + EndPoints.GET_STATE_LIST);
  }

  async setStateList() {
  if (isNullOrUndefined(this.localStorageService.getItem(Constants.LOCAL_STATE_LIST))) {
    await this.getStateList().then(stateList => {
      this.localStorageService.setItem(Constants.LOCAL_STATE_LIST, JSON.stringify(stateList));
    });
  }
}

  async setRaceAndEthnicityList() {
    if (isNullOrUndefined(this.localStorageService.getItem(Constants.LOCAL_RACE_LIST))) {
        await this.getRaceAndEthnicity(EnumType.Race).then((res: any) => {
        res.sort((a: { sequence: number; }, b: { sequence: number; }) => a.sequence - b.sequence);
        this.localStorageService.setItem(Constants.LOCAL_RACE_LIST, JSON.stringify(res));
      });
    }

    if (isNullOrUndefined(this.localStorageService.getItem(Constants.LOCAL_ETHNICITY_LIST))) {
        await this.getRaceAndEthnicity(EnumType.Ethnicity).then((res: any) => {
        res.sort((a: { sequence: number; }, b: { sequence: number; }) => a.sequence - b.sequence);
        this.localStorageService.setItem(Constants.LOCAL_ETHNICITY_LIST, JSON.stringify(res));
      });
    }
  }

}
